/**
 * R1's account home profile header: avatar, display name, `@username`, and
 * an `Edit profile` action into the shipped `/account/edit` screen.
 */
import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";

import { ProfileAvatar } from "../profile/ProfileAvatar";
import { EDIT_PROFILE_ACTION } from "./accountHomeCopy";

export type typeAccountProfileHeaderProps = {
  displayName: string;
  username: string;
  photoUrl: string | null;
  testId?: string | undefined;
};

export const AccountProfileHeader = (
  props: typeAccountProfileHeaderProps,
): ReactNode => (
  <header
    className="flex flex-col items-center gap-3 text-center sm:flex-row sm:items-center sm:gap-4 sm:text-left"
    data-testid={props.testId}
  >
    <ProfileAvatar
      displayName={props.displayName}
      photoUrl={props.photoUrl}
      size="md"
      labelling="decorative"
      testId="account-avatar"
    />
    <div className="flex flex-col gap-1">
      <h1 className="text-h1 text-ink" data-testid="account-display-name">
        {props.displayName}
      </h1>
      <p
        className="text-body text-ink-secondary"
        data-testid="account-username"
      >
        {`@${props.username}`}
      </p>
    </div>
    <Link
      to="/account/edit"
      data-testid="account-edit-profile"
      className="inline-flex min-h-touch-target items-center text-body-strong text-primary underline-offset-2 hover:underline"
    >
      {EDIT_PROFILE_ACTION}
    </Link>
  </header>
);
